module.exports = "../content/465d1affcd03e9c6096f3313a47e0bf5.ttf";